const buildBreakdownMap = breakdown => {
  const map = {};
  breakdown.forEach(item => {
    map[item.name] = item.weight;
  });
  return map;
};

export default buildBreakdownMap;
